import { PartsDiagramModalProps } from '../types';
import { CatModal } from '@blocks-react/components/Modal';
import styles from '../PartsDiagram.module.scss';
export const PartsDiagramModal = ({
  children,
  className,
  ...modalProps
}: PartsDiagramModalProps) => {
  return (
    <CatModal
      {...modalProps}
      fullWidth
      className={styles['part-diagram-modal']}
    >
      {children}
    </CatModal>
  );
};
